import type { AppLocale } from "./locale";

/** Public Mini App feature. Personal settings still require signed Telegram auth. */
export const FUEL_ENABLED = true;
export function fuelAvailable(website: boolean): boolean {
  return FUEL_ENABLED && !website;
}
export const fuelEntryCopy: Record<AppLocale, { title: string; subtitle: string; error: string }> = {
  ru: { title: "Топливо", subtitle: "Цены на карте", error: "Не удалось открыть. Попробуйте ещё раз." },
  ro: { title: "Carburanți", subtitle: "Prețuri pe hartă", error: "Nu s-a putut deschide. Încercați din nou." },
  uk: { title: "Пальне", subtitle: "Ціни на карті", error: "Не вдалося відкрити. Спробуйте ще раз." },
};
